import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = () =>
  createStyles({
    root: {
      height: '100%',
      width: '100%',
    },
    cardWrapper: {
      padding: 8,
    },
  });

export type Styles = WithStyles<typeof styles>;
